// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"search-module--subscribe--3TFXf","input":"search-module--input--1fev8","buttonWrapper":"search-module--button-wrapper--10VRu"};